import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { payslips } from './data';
import { formatLabel, formatDescription, formatAmount } from './formatting';
import Mobile from '../../components/Mobile';

export default function Payslip() {
  const navigate = useNavigate();
  const params = useParams();

  const handleBack = () => {
    navigate(`/payslips${window.location.search.toString()}`);
  };

  const handlePDF = () => {
    navigate(`/payslips/${params.id}/pdf${window.location.search.toString()}`);
  };

  const payslip = React.useMemo(() => {
    if (params.id) {
      const id = parseInt(params.id, 10);
      return payslips[id];
    }

    return undefined;
  }, [
    params.id,
  ]);

  if (!payslip) {
    return undefined;
  }

  const settlement = payslip.amount * 0.1;
  const net = payslip.amount - settlement;
  const total = settlement + net;

  return (
    <div className="mobile-layout">
      <div className="mobile-content">
        <div className="m-16">
          <div className="mobile-title">
            <h1>{formatLabel(payslip.month)}</h1>
            <h2>{formatDescription(payslip.month)}</h2>
          </div>
          <div className="list">
            <table>
              <thead>
                <tr>
                  <th className="list-strong">Overview</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="list-summary">Gross salaries</td>
                  <td className="list-value">{formatAmount(total)}</td>
                </tr>
                <tr>
                  <td className="list-summary">Net</td>
                  <td className="list-value">{formatAmount(net)}</td>
                </tr>
                <tr>
                  <td className="list-summary">Subsequent settlement from previous months</td>
                  <td className="list-value">{formatAmount(settlement)}</td>
                </tr>
                <tr>
                  <td className="list-total-label">Transfer amount</td>
                  <td className="list-total">{formatAmount(total)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="mobile-footer">
        <div>
          <button type="button" className="btn" onClick={handlePDF}>Open as PDF</button>
          <Mobile>
            <button type="button" className="btn btn-outline" onClick={handleBack}>Back</button>
          </Mobile>
        </div>
      </div>
    </div>
  );
}
